import "./MsActivationLinkExpired.css";
import { useConfig } from "../../contexts/ConfigContext";
import { useTranslation } from "react-i18next";

function ActivationLinkExpired() {
  const { config } = useConfig();
  const bambora_url = config?.reportalLoginUrlMS1;
  const { t } = useTranslation();
  return (
    <div className="activation-expired-root">
      <div className="activation-expired-content">
        <img src="/ciam/v1/static/images/ms/Broken_link.svg" alt="Broken" />
        <div>
          <h1 className="activation-expired-title">{t("ms.link.expired.title")}</h1>

          <p className="activation-expired-text">
            {t("ms.link.expired.header")}
            <a href={bambora_url} target="_blank" rel="noopener noreferrer">
              {t("ms.link.expired.report.url")}
            </a>
            {t("ms.link.expired.report.text")}
          </p>
        </div>

        <div className="activation-expired-footer">
          <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
        </div>
      </div>
    </div>
  );
}

export default ActivationLinkExpired;
